import { observer } from "mobx-react-lite";
import { GroupParam, Parameter } from "@/queries/models/types";

import { useState, useEffect } from "react";
import { ParameterItem } from "./ParameterItem";
import { processDefaultValue } from "./utils";
import { AddNewGroupParameter } from "./AddNewGroupParameter";
import { AnimatePresence } from "framer-motion";
import { BuilderProps } from "../types";

export const GroupParameterBuilder = observer(
  ({ parameter, isViewing, isNested }: BuilderProps) => {
    const [originalParameters, setOriginalParameters] = useState<Parameter[]>(
      [],
    );

    useEffect(() => {
      return () => {
        parameter.updateParameter({
          ...parameter.getParameter,
          default: processDefaultValue(parameter.getParameter),
        });
      };
    }, [parameter]);

    const handleDeleteParameterFromGroup = (paramIndex: number) => {
      if (!parameter) return;

      const groupParam = parameter.getParameter as GroupParam;

      const updatedParameters = [...groupParam.parameters];
      updatedParameters.splice(paramIndex, 1);

      parameter.updateGroupParameters(updatedParameters);
    };

    const handleStartEdit = () => {
      if (!parameter || !parameter.groupParameters) return;

      const groupParam = parameter.getParameter as GroupParam;
      setOriginalParameters([...groupParam.parameters]);
    };

    const groupParameters = parameter?.groupParameters || [];

    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h4 className="text-sm font-medium text-gray-700">
            Parameters in this group
          </h4>
          <AddNewGroupParameter
            isNested={isNested}
            isViewing={isViewing}
            parameter={parameter}
          />
        </div>

        <div className="space-y-2">
          {groupParameters.length > 0 ? (
            <div className="space-y-3">
              <AnimatePresence initial={false}>
                {groupParameters.map((param, index) => (
                  <ParameterItem
                    key={`group-parameter-${param.paramId || index}`}
                    parameter={param}
                    index={index}
                    onDelete={handleDeleteParameterFromGroup}
                    onCancel={() =>
                      parameter.updateGroupParameters(originalParameters)
                    }
                    handleStartEdit={handleStartEdit}
                    isViewing={isViewing}
                  />
                ))}
              </AnimatePresence>
            </div>
          ) : (
            <div className="flex items-center justify-center rounded-md border border-dashed border-gray-300 py-4">
              <p className="text-sm text-gray-500">
                No parameters in this group yet
              </p>
            </div>
          )}
        </div>
      </div>
    );
  },
);
